module.exports = __webpack_public_path__ + "img/community-explore.2516d5f2.svg";